






















import { Facet } from '@empathy/search-types';
import { Component, Prop, Vue } from 'vue-property-decorator';

@Component
export default class FacetSearch extends Vue {

  @Prop({ required: true })
  facet: Facet;
  @Prop()
  startsOpen: boolean;
  @Prop()
  toggleable: boolean;

  protected query = '';
  protected showSearchBox = !this.toggleable || this.startsOpen;

  get placeholderParams(): any {
    return { title: this.$x.messages.facets.titles[this.facet.title] || this.facet.title };
  }

  clearInput() {
    this.query = '';
    this.emitQueryUpdated();
  }

  emitQueryUpdated() {
    this.$emit('queryUpdated', this.query);
  }

  toggleSearch() {
    if (this.toggleable) {
      this.showSearchBox = !this.showSearchBox;
      this.$emit('toggledSearch', this.showSearchBox);
      if (this.showSearchBox) {
        Vue.nextTick(() => (this.$refs.input as HTMLElement).focus());
      } else {
        this.clearInput();
      }
    }
  }
}
